import styled from 'styled-components';

export const TodoAddInputStyled = styled.input`
    outline: none;
    border: none;
    background-color: transparent;
    border-bottom: 2px solid #9D9D9D;
    font-size: 50px;
    width: 900px;
    padding:10px 15px;
    font-family: 'Rubik', sans-serif;
    color: ${function() {
            switch(localStorage.getItem('theme')) {
                case 'dark':
                    return 'white';
                    break;
                case 'light':
                    return 'black';
                    break;
                default:
                    return 'black';
            }
        }};

    &::placeholder {
        color: #C6C6C6;
    }

    @media screen and (max-width: 768px){
        font-size: 40px;
    }

    @media screen and (max-width: 576px){
        width: 100%;
        font-size: 20px;
    }
`;